import { render, staticRenderFns } from "./LoaderSvg.vue?vue&type=template&id=232c3506&"
import script from "./LoaderSvg.vue?vue&type=script&lang=js&"
export * from "./LoaderSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports